import {Component, OnInit} from "@angular/core";
import {Announcement, AnnouncementService} from "../../../services/announcement.service";
import {finalize, Observable, of, Subscription, switchMap, tap} from "rxjs";
import {CurrentTenantService} from "../../../services/front/current-tenant.service";
import {TenantOverview} from "../../../services/tenant.service";
import {CommonModule} from "@angular/common";
import {TopbarService} from "../../../services/front/topbar.service";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {DesignSystemModule} from "../../design-system/design-system.module";
import {AnnouncementListComponent} from "./announcement-list/announcement-list.component";

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss'],
  imports: [
    CommonModule,
    DesignSystemModule,
    AnnouncementListComponent,
    TranslateModule
  ]
})
export class AnnouncementComponent implements OnInit {
  protected announcementList: Announcement[] = [];
  private subscription = new Subscription();
  protected tenant: TenantOverview;
  protected isLoading= false;

  constructor(
    private currentTenantService: CurrentTenantService,
    private announcementService: AnnouncementService,
    private topBarService: TopbarService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.topBarService.onTitleChange(this.translateService.instant('page.announcement.title'), this.translateService.instant('page.announcement.subtitle'));

    this.subscription.add(this.currentTenantService.getCurrentTenantChanges()
      .pipe(tap(tenant => this.tenant = tenant))
      .subscribe(() => this.initialize()));
  }

  initialize(): void {
    this.subscription.add(this.switchLoading()
      .pipe(
        switchMap(() => this.announcementService.getAnnouncements(this.tenant.configuration.id)),
        tap(data => this.setAnnouncements(data)),
        finalize(() => this.switchLoading()))
      .subscribe());
  }

  private switchLoading(): Observable<{}> {
    this.isLoading = !this.isLoading;
    return of({});
  }

  private setAnnouncements(data: Announcement[]): void {
    this.announcementList = data.map(announcement => {
      announcement.createdAt = new Date(announcement.createdAt)
      announcement.updatedAt = new Date(announcement.updatedAt)
		announcement.startDate = new Date(announcement.startDate)

      let teamsTooltip: {
        id: string
        parentName: string
        teams: {
          name: string
        }[]
      }[] = []

      announcement.teams?.forEach(team => {
        const parent = teamsTooltip.find(parent => parent.id === team.parentId)
        if (parent) {
          teamsTooltip.find(parent => parent.id === team.parentId)?.teams.push({ name: team.name })
        } else {
          teamsTooltip.push({
            id: team.parentId,
            parentName: team.parentName,
            teams: [{ name: team.name }]
          })
        }
      })
      announcement.teamsTooltip = teamsTooltip
      return announcement
    });
  }

  openDocumentation() {
    window.open(this.translateService.instant('page.agent.workstations.documentationUrl'), '_blank');
  }
}
